import {ModuleState} from '@gongxigames/framework/slot/fragments/module/ModuleState';
import {FlowModuleEvents} from '@gongxigames/framework/slot/modules/flow/FlowModuleEvents';
import {BuyBonusPopUpEvents} from '@gongxigames/framework/slot/modules/buyBonus/buyBonusPopUp/BuyBonusPopUpEvents';
import {Action} from 'com/gongxigames/math/core/game/enums/Action';
import {UIDisableReason} from '@gongxigames/framework/slot/modules/keypad/UIDisableReason';
import {BuyBonusButtonView} from '@gongxigames/framework/slot/modules/buyBonus/buyBonusButton/BuyBonusButtonView';
import {BuyBonusButtonModule} from '@gongxigames/framework/slot/modules/buyBonus/buyBonusButton/BuyBonusButtonModule';

export class BuyBonusButtonFeatureState extends ModuleState<BuyBonusButtonView, BuyBonusButtonModule> {
    public onEnterState(): void {
        this.view.disableButton();
    }

    public onLeaveState(): void {
        this.module.enableByName(UIDisableReason.TRIGGERING_FEATURE);
    }

    protected setupEvents(): void {
        this.setEventHandler(FlowModuleEvents.ENTER_BASIC_STATE, this.checkIfSpinNext.bind(this));
        this.setEventHandler(BuyBonusPopUpEvents.BUY_POP_UP_CLOSED, this.checkIfSpinNext.bind(this));
    }

    protected checkIfSpinNext(): void {
        if (this.module.logic.nextAction === Action.SPIN) {
            this.onFeatureFinished();
        }
    }

    protected onFeatureFinished(): void {
        this.module.gotoState(BuyBonusButtonModule.BASIC_STATE);
    }
}
